export default "__VITE_ASSET__DO82$jBM__"